import React from 'react';
import { connect } from 'react-redux';
import {Switch, Route} from 'react-router-dom';
import {withRouter} from 'react-router-dom';

import Root from "./containers/Root";
import NotFound from './containers/NotFound';
import Sign from './containers/Sign';
import Logout from './containers/Logout';
import ForgottenPassword from './containers/ForgottenPassword';

import SessionStore from './components/Stores/SessionStore';
import * as NotificationsActionCreators from './redux/actions/notificationsActions';

import apiRoutes from './apiRoutes'

import 'react-notifications/dist/react-notifications.css';

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...apiRoutes,
            sessionData: {
                accessToken: null,
                loggedUser: null
            },
        };

        this.requireAuth = this.requireAuth.bind(this);
    }

    requireAuth() {
        const sessionStore = new SessionStore();
        const accessToken = sessionStore.readToken();
        const pathname = this.props.location.pathname.split('/')[1];
        if (accessToken) {
            let sessionData = this.state.sessionData;
            sessionData.accessToken = accessToken;
            sessionData.loggedUser = sessionStore.readUser();
        } else if (pathname !== 'Sign' && pathname !== 'ForgottenPassword'){
            this.props.history.push('/Sign');
        }
    }

    componentWillUpdate() {
        this.requireAuth();
    }

    componentDidMount() {
        this.requireAuth();
        let date = new Date();
        this.props.addNotification('welcome', null, 'Vítám tě, dnes je: ' + date.toLocaleDateString() + ' ' + date.toLocaleTimeString() +'.');
    }

    render () {
        const {api, sessionData} = this.state;

        return (
            <Switch>
                <Route path="/Sign" component={(props) => <Sign {...props} api={api} sessionData={sessionData}/>}/>
                <Route path="/Logout" component={(props) => <Logout {...props} api={api}/>}/>
                <Route path="/ForgottenPassword" component={(props) => <ForgottenPassword {...props} api={api}/>}/>
                <Route exact path='/' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Admins' component={(props) => <Root {...props} api={api} sessionData={sessionData} />}/>
                <Route path='/Avatars' component={(props) => <Root {...props} api={api} sessionData={sessionData} />}/>
                <Route path='/Awards' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/TakenAwards' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Badges' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/EducationMaterials' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Help' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Newsfeeds' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Notifications' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>} />
                <Route path='/Profile' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Questions' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Settings' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Specials' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/Statistics' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>>}/>
                <Route path='/Users' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path='/UserStories' component={(props) => <Root {...props} api={api} sessionData={sessionData}/>}/>
                <Route path="*" component={NotFound} status={404}/>
            </Switch>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
        toggleRead: (index) => dispatch(NotificationsActionCreators.toggleRead(index))
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/